import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL || '/'

// axios.defaults.headers.common['Content-Type'] = 'application/form-data'

axios.interceptors.response.use(response => {
  return response
}, error => {
  // try to throw response of error, else throw error
  return Promise.reject(error.response || error)
})

// TODO update BE to use header token
// // request interceptor to add access token to each request
// axios.interceptors.request.use(config => {
//   const accessToken = UserBus.token

//   if (accessToken !== null) {
//     config.headers[AUTH_HEADER_NAME] = accessToken
//   }

//   return config
// }, err => {
//   return Promise.reject(err)
// })
